<div class="rex-avatar__image" [style.backgroundImage]="'url(' + src + ')'" *ngIf="src"></div>
<a3l-ui-icon icon="user" *ngIf="!src"></a3l-ui-icon>
